import { AiReviewFinishScreen } from "@/modes/ai-asset-review-mode/ui-components/ai-review-finish-screen";
import { AiReviewMainContent } from "@/modes/ai-asset-review-mode/ui-components/ai-review-main-content";
import { AiReviewSidebar } from "@/modes/ai-asset-review-mode/ui-components/ai-review-sidebar";
import { selectAiReviewStats } from "@/store/ai-asset-review/ai-asset-review-selectors";
import { useAppSelector } from "@/store/store-hooks";
import { Stack } from "@mui/material";
import type { JSX } from "react";

/** @returns The overlay for the AI Asset Review mode */
export function AiAssetReviewOverlay(): JSX.Element {
  const stats = useAppSelector(selectAiReviewStats);
  const isReviewComplete = stats.remaining === 0 && stats.total > 0;

  // Show finish screen when all annotations are reviewed
  if (isReviewComplete) {
    return (
      <Stack
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          overflow: "auto",
        }}
      >
        <AiReviewFinishScreen />
      </Stack>
    );
  }

  return (
    <Stack
      direction="row"
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "auto",
      }}
    >
      {/* Left: Main content area */}
      <AiReviewMainContent />

      {/* Right: Sidebar */}
      <AiReviewSidebar />
    </Stack>
  );
}
